import { createSelector } from "reselect";

export const metricDashboardSelector = createSelector(
    state => state.metric.dashboard,
    state => state
);

export const metricDashboardTasksSelector = createSelector(
    state => state.metric.dashboard.tasks,
    state => state
);

export const metricDashboardDataSelector = createSelector(
    state => state.metric.dashboard.data,
    state => state
);

export const metricTaskCodeSelector = createSelector(
    state => state.metric.dashboard.code,
    state => state
);

export const metricTaskLastStartAtSelector = createSelector(
    state => state.metric.dashboard.lastStartAt,
    state => state
);

export const metricTaskColorsSelector = createSelector(
    state => state.metric.dashboard.colors,
    state => state
);

export const metricGroupCodeSelector = createSelector(
    state => state.metric.dashboard.groupCode,
    state => state
);

export const metricPercentProgressSelector = createSelector(
    state => state.metric.dashboard.percentProgress,
    state => state
);

export const metricUpdatingDialogSelector = createSelector(
    state => state.metric.dashboard.updatingDialog,
    state => state
);

export const metricGraphDialogSelector = createSelector(
    state => state.metric.dashboard.graphDialog,
    state => state
);

export const currentTaskDataSelector = createSelector(
    state => state.metric.dashboard.currentTask,
    state => state
);
